import React from 'react'
import PropTypes from 'prop-types'
import FieldsetItem from 'components/FieldsetItem'
import {
  DescriptionContainer,
  StyledLicenseItem,
} from './styles'

const buildLicenseDisplay = license => {
  return `${license.product ? license.product.description : license.id} 
    (${new Date(license.startDate).toLocaleDateString()} - 
     ${new Date(license.expirationDate).toLocaleDateString()})`      
}

export const MergeSiteDescription = ({ site, siteUserCount }) => {
  return <DescriptionContainer>
    <FieldsetItem
      data={site.id}
      title="Site ID"
    />
    <FieldsetItem
      data={site.name}
      title="Name"
    />
    {
      site.netSuiteCustomer &&
      <FieldsetItem
        data={site.netSuiteCustomer.nsCustomerId}
        title="NSCustomer ID"
      />
    }
    <FieldsetItem
      data={site.organization.name}
      title="Organization Name"
    />
    {
      site.organization.netSuiteCustomer &&
      <FieldsetItem
        data={site.organization.netSuiteCustomer.nsCustomerId}
        title="Organization NSCustomer ID"
      />
    }
    <FieldsetItem
      data={siteUserCount}
      title="Site users Count"
    />
    <h5>Licenses:</h5>
    {
      site.licenses.length > 0 ? site.licenses.map( license => { 
        return <StyledLicenseItem key={ 'license-item' + license.id }>
            {buildLicenseDisplay(license)}
          </StyledLicenseItem>    
      })
      :
      "No Licenses assigned"
    }
  </DescriptionContainer>
}

MergeSiteDescription.propTypes = {
  site: PropTypes.shape({
    name: PropTypes.string,
    licenses: PropTypes.array,
    organization: PropTypes.object,
    netSuiteCustomer: PropTypes.object,
  }),
  siteUserCount: PropTypes.number
}

export default MergeSiteDescription


// WEBPACK FOOTER //
// ./src/components/MergeSiteDescription/MergeSiteDescription.js